import { TABLE_SORT_AESC, TABLE_SORT_DESC } from './Constant';
import {
  ColumnHeaderType,
  LocationFilterInitialState,
  MapOptionType,
  SelectOptionType,
} from './Types';

export const findValueInOptions = (options: SelectOptionType[], id: any) => {
  for (const element of options) {
    if (Number(element?.value) === Number(id)) {
      return element.label;
    }
  }
  return '-';
};

export const findValueInMap = (
  map: MapOptionType = {},
  id: any,
  parentId?: any
) => {
  const array = parentId ? map[parentId] ?? [] : Object.values(map).flat();
  for (const element of array) {
    if (Number(element.value) === Number(id)) {
      return element.label;
    }
  }
  return '-';
};
export const findValueFromLocalStore = (
  headerItem: ColumnHeaderType,
  item: any,
  locationData: LocationFilterInitialState,
  roleOption: SelectOptionType[]
) => {
  const field = headerItem.field;
  const id = item[field as keyof any];

  if (field.includes('zone')) {
    return findValueInOptions(locationData?.zoneOptions, id);
  } else if (field.includes('state')) {
    return findValueInMap(locationData.statesData, id);
  } else if (field.includes('district')) {
    const stateId = item.state ?? item.stateId;
    return findValueInMap(locationData.districtData, id, stateId);
  } else if (field.includes('city')) {
    const districtId = item.district ?? item.districtId;
    return findValueInMap(locationData.cityOptions, id, districtId);
  } else if (field.includes('role')) {
    return findValueInOptions(roleOption, id);
  }
  return '-';
};

export const findValue = (
  headerItem: ColumnHeaderType,
  item: any,
  locationData: LocationFilterInitialState,
  roleOption: SelectOptionType[]
) => {
  if (headerItem.valueFromLocalStorage) {
    return findValueFromLocalStore(headerItem, item, locationData, roleOption);
  } else if (headerItem.valueGetter) {
    return headerItem.valueGetter(item, headerItem.field, locationData) ?? '-';
  } else if (headerItem.value) {
    return headerItem.value ?? '-';
  } else {
    return item[headerItem.field] ?? '-';
  }
};

export const handleSort = (
  field: string,
  sortBy: string | null,
  sortOrder: string,
  setSortOrder: (order: string) => void,
  setSortBy: (sortByData: string) => void
) => {
  if (field === sortBy) {
    setSortOrder(
      sortOrder === TABLE_SORT_AESC ? TABLE_SORT_DESC : TABLE_SORT_AESC
    );
  } else {
    setSortBy(field);
    setSortOrder(TABLE_SORT_AESC);
  }
};

export const findSelectValue = (
  headerItem: ColumnHeaderType,
  item: any,
  array?: SelectOptionType[]
) => {
  const value = item[headerItem.field as keyof any];
  const selectValue = array?.find(
    (item: SelectOptionType) => item.label === value
  );
  return selectValue;
};
